/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { utilities } from '@weatherbug/common';
import { getQueryParameterByName } from '../../common/utilities/queryParameters';
import { reduxConnect } from '../../common';

interface TemperatureReadingProps {
    currentTemperature?: string;
}

const defaultForecastUnits = '1';
const defaultTempValue = '--';
const { units, unitConversion } = utilities;
const { temperatureUnitAbbreviations } = units;
const { getTemperature } = unitConversion;

const mapStoreStateToProps = (storeState: object) => {
    const { weatherWidget } = storeState || {};
    const { currentTemperature } = weatherWidget || {};

    return {
        currentTemperature
    };
};

const mapDispatchToProps = {};

export const TemperatureReading = reduxConnect( mapStoreStateToProps, mapDispatchToProps )(memo((
    { 
        currentTemperature = defaultTempValue 
    }: TemperatureReadingProps
) => {
    
    const qpUnits = getQueryParameterByName('units');
    const currentObsUnits = parseInt(qpUnits) >= 0 ? Number(qpUnits) : null;
    const currentForecastUnits = temperatureUnitAbbreviations[currentObsUnits] || temperatureUnitAbbreviations[defaultForecastUnits];
    const temperatureValue = currentTemperature !== defaultTempValue && currentObsUnits >=0 
        ? getTemperature(currentTemperature, currentObsUnits) 
        : defaultTempValue;

    return (
        <TemperatureReadingContainer>
            <TempVal>{temperatureValue}</TempVal>
            <CondUnits>{currentForecastUnits}</CondUnits>
        </TemperatureReadingContainer>
    );
}));

TemperatureReading.displayName = 'TemperatureReading';

const TemperatureReadingContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 40%;
    height: 100%;
`;

const TempVal = styled.div`
    display: flex;
    align-items: center;
    text-align: right;
    color: #FFFFFF;
    font-size:10vw;
    font-weight: bold;
`;

const CondUnits = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 20%;
    height: 100%;
    color: #f7f8fa;
    margin-left: 2px;
    font-size: 9vw;
`;